import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { IWatchdog } from "../types";

type TInput = IWatchdog;
type TOutput = void;

export default class ChangeWatchdogApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.PUT;

  resolveUri({ id }: TInput): string {
    return `/fe-api/watchdog/${id}`;
  }

  mapRequestData({ id, frequencyId, name, filter }: TInput): any {
    const {
      priceFrom,
      priceTo,
      acreageFrom,
      acreageTo,
      dispositions,
      furnishing,
      conveniences,
    } = filter;

    return {
      id,

      frequency_id: frequencyId,
      name,
      search: {
        offer_type_id: null,
        dispositions,
        price_from: priceFrom,
        price_to: priceTo,
        acreage_from: acreageFrom,
        acreage_to: acreageTo,
        added_before: "",
        furnishing,
        conveniences,
        is_price_commision_free: null,
        sort_by: "",
        page: 1,
        limit: 20,
        bounds: {
          north_east: filter.bounds.northEast,
          south_west: filter.bounds.southWest,
        },
      },
    };
  }
}
